/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getBloodBanks } from 'app/entities/blood-bank/blood-bank.reducer';
import { getUsers } from 'app/shared/reducers/user-management';
import { getEntities as getContactDetails } from 'app/entities/contact-details/contact-details.reducer';
import { Gender } from 'app/shared/model/enumerations/gender.model';
import { BloodGroup } from 'app/shared/model/enumerations/blood-group.model';
import { createEntity, getEntity, reset, updateEntity } from './blood-bank-employee.reducer';

export const BloodBankEmployeeUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const bloodBanks = useAppSelector(state => state.bloodBank.entities);
  const users = useAppSelector(state => state.userManagement.users);
  const contactDetails = useAppSelector(state => state.contactDetails.entities);
  const bloodBankEmployeeEntity = useAppSelector(state => state.bloodBankEmployee.entity);
  const loading = useAppSelector(state => state.bloodBankEmployee.loading);
  const updating = useAppSelector(state => state.bloodBankEmployee.updating);
  const updateSuccess = useAppSelector(state => state.bloodBankEmployee.updateSuccess);
  const genderValues = Object.keys(Gender);
  const bloodGroupValues = Object.keys(BloodGroup);

  const handleClose = () => {
    navigate(`/blood-bank-employee${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getBloodBanks({}));
    dispatch(getUsers({}));
    dispatch(getContactDetails({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.dateOfBirth !== undefined && typeof values.dateOfBirth !== 'number') {
      values.dateOfBirth = Number(values.dateOfBirth);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...bloodBankEmployeeEntity,
      ...values,
      bloodBank: bloodBanks.find(it => it.id.toString() === values.bloodBank?.toString()),
      user: users.find(it => it.id.toString() === values.user?.toString()),
      contactDetails: contactDetails.find(it => it.id.toString() === values.contactDetails?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          gender: 'NA',
          bloodGroup: 'O_POS',
          ...bloodBankEmployeeEntity,
          bloodBank: bloodBankEmployeeEntity?.bloodBank?.id,
          user: bloodBankEmployeeEntity?.user?.id,
          contactDetails: bloodBankEmployeeEntity?.contactDetails?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.bloodBankEmployee.home.createOrEditLabel" data-cy="BloodBankEmployeeCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.bloodBankEmployee.home.createOrEditLabel">Create or edit a BloodBankEmployee</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="blood-bank-employee-id"
                  label={translate('tinyMedicRestApp.bloodBankEmployee.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankEmployee.education')}
                id="blood-bank-employee-education"
                name="education"
                data-cy="education"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankEmployee.training')}
                id="blood-bank-employee-training"
                name="training"
                data-cy="training"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankEmployee.experience')}
                id="blood-bank-employee-experience"
                name="experience"
                data-cy="experience"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankEmployee.achievements')}
                id="blood-bank-employee-achievements"
                name="achievements"
                data-cy="achievements"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankEmployee.name')}
                id="blood-bank-employee-name"
                name="name"
                data-cy="name"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankEmployee.email')}
                id="blood-bank-employee-email"
                name="email"
                data-cy="email"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankEmployee.dateOfBirth')}
                id="blood-bank-employee-dateOfBirth"
                name="dateOfBirth"
                data-cy="dateOfBirth"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankEmployee.gender')}
                id="blood-bank-employee-gender"
                name="gender"
                data-cy="gender"
                type="select"
              >
                {genderValues.map(gender => (
                  <option value={gender} key={gender}>
                    {translate(`tinyMedicRestApp.Gender.${gender}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankEmployee.bloodGroup')}
                id="blood-bank-employee-bloodGroup"
                name="bloodGroup"
                data-cy="bloodGroup"
                type="select"
              >
                {bloodGroupValues.map(bloodGroup => (
                  <option value={bloodGroup} key={bloodGroup}>
                    {translate(`tinyMedicRestApp.BloodGroup.${bloodGroup}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankEmployee.active')}
                id="blood-bank-employee-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankEmployee.cursor')}
                id="blood-bank-employee-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankEmployee.lastUpdated')}
                id="blood-bank-employee-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankEmployee.microSec')}
                id="blood-bank-employee-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankEmployee.timestampEntry')}
                id="blood-bank-employee-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                id="blood-bank-employee-bloodBank"
                name="bloodBank"
                data-cy="bloodBank"
                label={translate('tinyMedicRestApp.bloodBankEmployee.bloodBank')}
                type="select"
              >
                <option value="" key="0" />
                {bloodBanks
                  ? bloodBanks.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="blood-bank-employee-user"
                name="user"
                data-cy="user"
                label={translate('tinyMedicRestApp.bloodBankEmployee.user')}
                type="select"
              >
                <option value="" key="0" />
                {users
                  ? users.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="blood-bank-employee-contactDetails"
                name="contactDetails"
                data-cy="contactDetails"
                label={translate('tinyMedicRestApp.bloodBankEmployee.contactDetails')}
                type="select"
              >
                <option value="" key="0" />
                {contactDetails
                  ? contactDetails.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/blood-bank-employee" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default BloodBankEmployeeUpdate;
